import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type DataReportClient, type RiskMatrixState } from '../types';

const updateClientDataReportCase: CaseReducer<
  RiskMatrixState,
  PayloadAction<DataReportClient>
> = (state, action) => {
  state.client.report = {
    ...state.client.report,
    ...action.payload,
  };

  return state;
};

export { updateClientDataReportCase };
